import { render, staticRenderFns } from "./ArAgingReminder.vue?vue&type=template&id=61dec20b&"
import script from "./ArAgingReminder.vue?vue&type=script&lang=ts&"
export * from "./ArAgingReminder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61dec20b')) {
      api.createRecord('61dec20b', component.options)
    } else {
      api.reload('61dec20b', component.options)
    }
    module.hot.accept("./ArAgingReminder.vue?vue&type=template&id=61dec20b&", function () {
      api.rerender('61dec20b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ArAgingReminder/ArAgingReminder.vue"
export default component.exports